module.exports = __webpack_public_path__ + "static/media/kassadin.8d12a3e9.png";